const imgTeamUiUxWorkGraphic2Ball = "./assets/figma/06744399-888e-4094-a77f-3c9a1652fb48.png";
const imgDingAiMain1 = "./assets/figma/3f40eef2-41f3-4d73-a5d4-24448488a8c6.png";
const imgDingGra11 = "./assets/figma/44d53fc0-4c0e-4aba-999c-43aa7af90707.png";
const imgDingGra23 = "./assets/figma/554a1c9f-5d33-4a7e-8ef9-c8cd1e546813.png";
const imgDingUiux1 = "./assets/figma/29105079-fac7-4038-9fa7-2cd2af4438e2.png";
const imgDingGoods1 = "./assets/figma/44be2ae2-a07f-4547-b594-fb273f499cb6.png";
const imgDingMotion1 = "./assets/figma/0fc74327-b9bf-4f28-8c37-b132ca51a745.png";
const imgRectangle245 = "./assets/figma/0470d51d-5596-4e3f-9712-8c5cae2ec5cf.png";
const imgLine21 = "./assets/figma/024cae05-40d5-40cd-8187-3cfbbb55f6fe.svg";
const img1 = "./assets/figma/17895adf-bae2-4edc-a3cc-7d725a15da27.svg";
const imgLine25 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine26 = "./assets/figma/004e04b2-2999-4bf9-a0ef-7d979948c643.svg";
const imgLine27 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";

export default function TeamUiUxWorkGraphic2Ball() {
  return (
    <div className="s0 s1" data-node-id="886:899" data-name="TEAM_UI/UX_WORK_GRAPHIC2BALL">
      <div aria-hidden className="s2 s3 s4">
        <div className="s2 s5 s3" />
        <img alt="" className="s2 s9 s105 s1" src={imgTeamUiUxWorkGraphic2Ball} />
      </div>
      <div className="s2 s539 s540 s541 s542" data-node-id="886:903" data-name="DING_AI_MAIN 1">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgDingAiMain1} />
      </div>
      <div className="s2 s12 s13 s543 s15" data-node-id="886:904" data-name="image 14" />
      <p className="s23 s2 s51 s94 s52 s27 s29 s33 s544 s54" data-node-id="886:905">
        LET THE IDEAS ROLL, PLAY THE LAB
      </p>
      <div className="s23 s2 s16 s17 s24 s25 s26 s55 s27 s29 s545 s57" data-node-id="886:906">
        <p className="s31 s32 s379 s0 s28 s58 s380" data-node-id="886:907">
          ABOUT
        </p>
        <div className="s35 s36 s0 s28 s37 s59 s38" data-node-id="886:908">
          <p className="s39 s40">
            {`UI/UX팀은 DING AI LAB에 참여한 여러 팀의 작업물과 AI 활용 과정을 한곳에 기록한 인터랙티브 아카이브 `}
            <br aria-hidden />
            웹사이트를 제작했다. 각 구슬은 하나의 프로젝트를 상징하며, 사용자는 구슬을 선택하고 굴리면서 결과물과 제작
            <br aria-hidden />
            {`과정을 순차적으로 탐색할 수 있다. 상세 페이지에는 사용한 AI, 프롬프트,  작업 과정과 활용 방법을 기록해 AI가`}
          </p>
          <p className="s39">아이디어 발상부터 이미지 제작, 디자인 수정과 결과 발전에 어떻게 사용되었는지 보여준다. 팀마다 AI를 선택하고 조합한 방식을 비교할 수 있으며, 구슬 중심의 인터랙션을 통해 능동적인 탐색 경험과 향후 AI 디자인 작업에 활용할 수 있는 참고 자료를 제공한다.</p>
        </div>
      </div>
      <p className="s23 s2 s31 s32 s476 s27 s29 s61 s546 s54" data-node-id="886:909">
        UI/UX
      </p>
      <div className="s2 s16 s17 s18 s19 s20 s547 s22" data-node-id="886:910">
        <div className="s23 s16 s17 s24 s25 s483 s26 s27 s0 s28 s29 s30" data-node-id="886:911">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="886:912">
            PROJECT OVERVIEW
          </p>
          <p className="s35 s39 s0 s28 s37 s34" data-node-id="886:913">
            INTERACTIVE WEBSITE
          </p>
        </div>
        <div className="s17 s41 s18 s42 s0 s28 s43" data-node-id="886:914">
          <div className="s44 s45">
            <div className="s46 s0 s47">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine21} />
              </div>
            </div>
          </div>
        </div>
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s50" data-node-id="886:915">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="886:916">
            MEMBERS
          </p>
          <div className="s35 s36 s0 s28 s37 s34" data-node-id="886:917">
            <p className="s39 s40">
              김근우
              <br aria-hidden />
              김시현
              <br aria-hidden />
              오한비
              <br aria-hidden />
              최진영
            </p>
            <p className="s39">​</p>
          </div>
        </div>
      </div>
      <p className="s23 s2 s31 s32 s20 s27 s29 s64 s548 s334" data-node-id="886:918">
        WORK
      </p>
      <div className="s106 s2 s549 s550 s185 s186 s187 s551 s36 s126 s552 s66" data-node-id="886:919">
        <div className="s192 s335 s336 s337 s197 s338 s0 s198 s199 s28" data-node-id="886:920">
          <div className="s192 s553 s595 s555 s0 s198 s556" data-node-id="1013:212" data-name="DING_GRA1 1">
            <img alt="" className="s2 s3 s9 s262 s4 s1" src={imgDingGra11} />
          </div>
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="886:922" />
        </div>
        <a className="s203 s141 s335 s336 s337 s572 s338 s0 s198 s202 s28" data-node-id="886:924">
          <div className="s192 s557 s596 s559 s0 s198 s560" data-node-id="1013:216" data-name="DING_GRA2 3">
            <img alt="" className="s2 s3 s9 s262 s4 s1" src={imgDingGra23} />
          </div>
          <div className="s192 s69 s561 s340 s82 s4 s0 s70 s198 s146 s71" data-node-id="886:926">
            <div aria-hidden className="s2 s3 s70" style={{ backgroundImage: "linear-gradient(90deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%), linear-gradient(90deg, rgba(255, 255, 255, 0.16) 0%, rgba(255, 255, 255, 0.16) 100%)" }} />
            <div className="s2 s3 s150 s151" />
          </div>
          <div className="s23 s192 s31 s597 s447 s27 s0 s198 s251 s115 s138 s253 s54" data-node-id="886:927">
            <p className="s249 s40">GRAPHIC 2</p>
            <p className="s249">BALL</p>
          </div>
        </a>
        <div className="s205 s335 s336 s337 s197 s338 s0 s198 s199 s28" data-node-id="886:928">
          <div className="s192 s562 s563 s564 s0 s198 s598" data-node-id="1013:215" data-name="DING_UIUX 1">
            <img alt="" className="s2 s3 s9 s262 s4 s1" src={imgDingUiux1} />
          </div>
          <div className="s80 s192 s81 s69 s599 s340 s82 s0 s70 s198 s576" data-node-id="886:930" />
        </div>
        <div className="s192 s335 s336 s337 s197 s338 s0 s206 s199 s28" data-node-id="886:932">
          <div className="s192 s568 s600 s569 s0 s198 s570" data-node-id="1013:214" data-name="DING_GOODS 1">
            <img alt="" className="s2 s3 s9 s262 s4 s1" src={imgDingGoods1} />
          </div>
          <div className="s80 s192 s81 s69 s339 s571 s82 s0 s70 s198 s71" data-node-id="886:934" />
        </div>
        <div className="s203 s335 s336 s337 s197 s338 s0 s206 s199 s28" data-node-id="886:936">
          <div className="s192 s561 s573 s0 s198 s589" data-node-id="1013:213" data-name="DING_MOTION 1">
            <img alt="" className="s2 s3 s9 s262 s4 s1" src={imgDingMotion1} />
          </div>
          <div className="s80 s192 s81 s69 s601 s571 s82 s0 s70 s198 s591" data-node-id="886:938" />
        </div>
      </div>
      <div className="s2 s102 s103 s10 s104" data-node-id="886:940">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgRectangle245} />
      </div>
      <div className="s106 s2 s16 s17 s18 s19 s107 s108 s109" data-node-id="886:941" data-name="navigationbar">
        <div className="s16 s17 s110 s26 s0 s28" data-node-id="886:942">
          <div className="s111 s0 s28 s112" data-node-id="886:943" data-name="_레이어_1">
            <img alt="" className="s2 s49 s3 s9 s1" src={img1} />
          </div>
          <p className="s23 s31 s113 s32 s27 s0 s28 s29 s114 s115 s116" data-node-id="886:948">
            DING AI LAB
          </p>
        </div>
        <div className="s16 s17 s117 s18 s0 s28" data-node-id="886:949">
          <div className="s16 s17 s24 s118 s18 s0 s28 s119" data-node-id="886:950">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="886:951">
              PROJECT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="886:952">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine25} />
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s123" data-node-id="886:953">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="886:954">
              TEAM
            </p>
            <div className="s46 s0 s28 s34" data-node-id="886:955">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine26} />
              </div>
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s124" data-node-id="886:956">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="886:957">
              ABOUT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="886:958">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine27} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}